import axios from 'axios'

const url = 'https://webmr.cl/api-covid19/api'

export async function getCountries() {
    const paises = await axios.get(`${url}/areas?mostrar=paises`)
    let data = []
    paises.data.data.forEach(pais => {
        // Australia, China, Congo, Barcos
        let excuidos = [17, 87, 91, 95, 238, 257]
        if (excuidos.indexOf(pais.id) === -1) {
            data.push({
                text: pais.nombre,
                value: pais.id
            })
        }
    })
    return data
}

export async function getCountryData(id, range) {
    let paises = await axios.get(`${url}/listar/${id}?desde=${range[0]}&hasta=${range[1]}`)
    return {
        data: paises.data.data[0].historia,
        habitantes: paises.data.data[0].areaData.habitantes,
        ultimaActualizacion: paises.data.data[0].lastUpdated
    }
}

export async function getRegiones() {
    let zones = await axios.get(`${url}/areas?mostrar=regiones`)
    zones.data.data.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
    return zones.data.data.map(zone => {
        return {
            text: zone.nombre,
            value: zone.id
        }
    })
}

export async function getRegionesData(id, range) {
    let regiones = await axios.get(`${url}/listar/${id}?desde=${range[0]}&hasta=${range[1]}`)
    return {
        data: regiones.data.data[0].historia,
        habitantes: regiones.data.data[0].areaData.habitantes,
        ultimaActualizacion: regiones.data.data[0].lastUpdated
    }
}

export async function getComunas(id) {
    if(id) {
        const zones = await axios.get(`${url}/region/${id}/comunas`)
        return zones.data.data.map(zones => {
            let key = zones.nombre
            return {
                text: key,
                value: zones.id
            }
        })
    } else {
        let zones = await axios.get(`${url}/areas?mostrar=comunas`)
        zones.data.data.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
        return zones.data.data.map(zone => {
            return {
                text: zone.nombre,
                value: zone.id
            }
        })
    }
}

export async function getComunasData(id, range) {
    let historia = {}
    const inicio = range[0]
    const fin = range[1]
    let comunas = await axios.get(`${url}/listar/${id}?desde=${inicio}&hasta=${fin}`)
    let history = comunas.data.data[0].historia
    let getDays = function (start, end) {
        for (var arr = [], dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
            arr.push(new Date(dt).toISOString().slice(0, 10));
        }
        return arr;
    };
    const days = getDays(new Date(inicio), new Date(fin)).reverse()

    for (var i = 0; i < days.length; i++) {
        if ( history[days[i]] ) {
            historia[days[i]] = history[days[i]]
        } else {
            historia[days[i]] = {}
        }
    }

    return {
        data: historia,
        habitantes: comunas.data.data[0].areaData.habitantes,
        ultimaActualizacion: comunas.data.data[0].lastUpdated
    }
}


